import{getStorageItem as t,setStorageItem as r}from"./storage.js";const o="dls_ab_testing_id",n=()=>{const n=t(o);if(!n){const t=Math.floor(100*Math.random()+1);return r(o,t.toString()),t}return Number(n)};export{n as getABTestingKey};
//# sourceMappingURL=abTestingKey.js.map
